import { render } from "./purchase-history.vue?vue&type=template&id=2ee2e766"
import script from "./purchase-history.vue?vue&type=script&lang=js"
export * from "./purchase-history.vue?vue&type=script&lang=js"

import "./purchase-history.vue?vue&type=style&index=0&id=2ee2e766&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__